import { proxy } from 'valtio'

type Names = {
  speakerId?: number
  sender: string
  full: string
}

const localNames = proxy<Names>({
  sender: window.localStorage.comment_name ?? 'You',
  full: window.localStorage.comment_full_name,
})

const getLocalName = () => {
  return {
    speakerId: localNames.speakerId,
    senderName: localNames.sender,
    fullName: localNames.full,
  }
}

const setLocalName = ({ speakerId, sender, full }: Names) => {
  localNames.speakerId = speakerId
  localNames.sender = sender
  localNames.full = full
}

export { getLocalName, setLocalName }
